/* jsl-sprzedaz.js (R8A, 24.09.2026) — zachowanie bloków sprzedaży J·SKIN LAB:
 *  • [data-jsl-dodaj="id,id"] — dodaje warianty do koszyka (z [data-jsl-z-formularzem] także wariant z formularza karty),
 *    potem zdarzenie motywu cart:update (odświeża szufladę, licznik, paski) i otwiera szufladę; bez szuflady → /cart;
 *  • [data-jsl-cookies] — „Ustawienia cookies” w stopce: otwiera preferencje banera zgód Shopify; gdy baner jest wyłączony
 *    w panelu (brak API), przycisk zostaje ukryty — nie obiecujemy ustawień, których nie ma.
 * Nic nie wysyła poza /cart/add.js i /cart.js tego sklepu. Działa raz, nawet gdy skrypt jest dołączony kilka razy. */
(function () {
  if (window.jslSprzedaz) return;
  window.jslSprzedaz = true;
  var RT = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  function api(sciezka, cialo) {
    return fetch(RT + sciezka, {
      method: cialo ? 'POST' : 'GET',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: cialo ? JSON.stringify(cialo) : undefined
    }).then(function (r) { if (!r.ok) throw new Error(r.status); return r.json(); });
  }
  function wariantKarty(el) {
    var sek = el.closest('product-information, .shopify-section, main') || document;
    var pole = sek.querySelector('form[data-type="add-to-cart-form"] [name="id"], product-form-component form [name="id"]');
    return pole && !pole.disabled ? pole.value : null;
  }

  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-jsl-dodaj]');
    if (!b || b.disabled) return;
    e.preventDefault();
    var ids = String(b.dataset.jslDodaj || '').split(',').filter(Boolean);
    if (b.hasAttribute('data-jsl-z-formularzem')) { var w = wariantKarty(b); if (w) ids.unshift(w); }
    if (!ids.length) return;
    var blad = (b.closest('[data-jsl-dop], [data-jsl-propozycja]') || document).querySelector('.jsl-dop__blad');
    b.disabled = true; b.setAttribute('aria-busy', 'true');
    api('cart/add.js', { items: ids.map(function (id) { return { id: Number(id), quantity: 1 }; }) })
      .then(function () { return api('cart.js'); })
      .then(function (cart) {
        var ev = new Event('cart:update', { bubbles: true });
        ev.detail = { resource: cart, sourceId: 'jsl-sprzedaz', data: { source: 'jsl-sprzedaz', itemCount: cart.item_count } };
        document.dispatchEvent(ev);
        var sz = document.querySelector('cart-drawer-component');
        if (sz && typeof sz.open === 'function') sz.open();
        else if (!document.querySelector('.cart-page')) window.location.href = RT + 'cart';
      })
      .catch(function () { if (blad) blad.hidden = false; })
      .then(function () { b.disabled = false; b.removeAttribute('aria-busy'); });
  });

  // stopka: „Ustawienia cookies” tylko wtedy, gdy baner zgód Shopify jest włączony
  function cookies() {
    var btn = document.querySelectorAll('[data-jsl-cookies]');
    if (!btn.length) return;
    var pb = window.privacyBanner;
    var ok = pb && typeof pb.showPreferences === 'function';
    btn.forEach(function (x) {
      var li = x.closest('li') || x;
      li.hidden = !ok;
      if (ok && !x.dataset.jslGotowe) { x.dataset.jslGotowe = '1'; x.addEventListener('click', function () { pb.showPreferences(); }); }
    });
  }
  if (document.readyState === 'complete') cookies(); else window.addEventListener('load', cookies);
  setTimeout(cookies, 3000);
})();
